module.exports = __webpack_public_path__ + "ea2b53d4d97f5f936e2eca750dea6eae.png";